import { observer } from 'mobx-react-lite';

import BookIcon from 'src/shared/assets/icons/book-light.svg';
import { Button } from 'src/shared/components/button';

type Props = {
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: VoidFunction;
};

export const GetDirectoryValuesButton = observer(function GetDirectoryValuesButton({
  isDisabled,
  isLoading,
  onClick,
}: Props) {
  return (
    <Button
      width={24}
      height={24}
      variant="default"
      disabled={isDisabled || isLoading}
      isLoading={isLoading}
      icon={<BookIcon fill="none" stroke="none" />}
      onClick={onClick}
    />
  );
});
